// extracted by mini-css-extract-plugin
export default {"floatingArea":"floating-area-module__floatingArea__LfuPR","show":"floating-area-module__show__TRdNX"};